import styled from 'styled-components'
import { grid, margin } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div
  .attrs({
    gridTemplateColumns: [
      `1fr`,
      `repeat(2, 1fr)`,
      `repeat(2, 1fr)`,
      `repeat(3, 1fr)`,
    ],
  })
  .withConfig({ shouldForwardProp })`
  width: 100%;
  display: grid;
  grid-gap: 16px;

  ${margin}
  ${grid}
`
